let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ggLwo")).then(() => parcelRequire('8pw0K'));